import { useEffect, useState } from 'react';
import LegalPageShell from '@/components/legal/LegalPageShell';
import { legalAssets } from '@/config/legal';

export default function PrivacyPolicyPage() {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(legalAssets.privacyPolicyHtml)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const main = doc.querySelector('main.container');
        setContent(main?.innerHTML ?? '');
      })
      .catch(() => setContent('<p>Unable to load privacy policy content.</p>'))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <LegalPageShell
      title="Privacy Policy"
      subtitle="Application: Sync360 | Last Updated: June 24, 2026"
      showPrivacyLink={false}
    >
      {isLoading ? (
        <p className="text-gray-500">Loading privacy policy...</p>
      ) : (
        <div
          className="privacy-policy-html [&_h1]:hidden [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-8 [&_h2]:mb-4 [&_h2]:text-gray-900 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-3 [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_li]:mb-2 [&_a]:text-blue-600 [&_a]:underline [&_.notice]:bg-blue-50 [&_.notice]:border [&_.notice]:border-blue-200 [&_.notice]:rounded-lg [&_.notice]:p-4 [&_.contact]:bg-gray-50 [&_.contact]:border [&_.contact]:border-gray-200 [&_.contact]:rounded-lg [&_.contact]:p-4"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </LegalPageShell>
  );
}
